import {
  ABOUT_BUSINESS_PAGE_KEY,
  TAX_FINANCE_PAGE_KEY,
  BUSINESS_FINANCE_PAGE_KEY,
  BUSINESS_DETAILS_PAGE_KEY,
  GDPR_PAGE_KEY,
  REVIEW_PAGE_KEY
} from './routingConstants';
import {
  ROUTE_ABOUT_YOUR_BUSINESS,
  ROUTE_TAX_FINANCE,
  ROUTE_BUSINESS_FINANCE,
  ROUTE_BUSINESS_CONCTACT_DETAILS,
  ROUTE_GDPR,
  ROUTE_REVIEW_PAGE
} from '../../utils/constants';

export const ROUTES_PAGE_CONFIGS = [
  {
    pageKey: ABOUT_BUSINESS_PAGE_KEY,
    path: ROUTE_ABOUT_YOUR_BUSINESS
  },
  {
    pageKey: TAX_FINANCE_PAGE_KEY,
    path: ROUTE_TAX_FINANCE
  },
  {
    pageKey: BUSINESS_FINANCE_PAGE_KEY,
    path: ROUTE_BUSINESS_FINANCE
  },
  {
    pageKey: BUSINESS_DETAILS_PAGE_KEY,
    path: ROUTE_BUSINESS_CONCTACT_DETAILS
  },
  {
    pageKey: GDPR_PAGE_KEY,
    path: ROUTE_GDPR
  },
  {
    pageKey: REVIEW_PAGE_KEY,
    path: ROUTE_REVIEW_PAGE
  }
];
